<template>
  <!-- <div v-if="success">
    <SuccessPage :registrationMethod="registrationMethod" />
  </div> -->
  <app-page-container :showNav="true">
    <div class="registration">
      <div class="registration-block">
        <div class="auth-header">
          <a href="/" class="auth-title">Cofocus</a>
          <div class="auth-subtitle">The land of co-productivity</div>
        </div>
        <div class="registration-form">
          <form class="auth-form" method="POST" @submit.prevent="register()">
            <div class="notifier__register">
              <!-- <h2>Errors</h2> -->
            </div>
            <div class="form-groups">
              <div class="form-group">
                <input v-model="email" class="auth-input" name="email" type="text" placeholder="Your email address" autocomplete="falsessy" />
                <div v-if="getError('email')" class="inputErrorContainer">
                  <div class="inputErrorText">{{ getError("email") }}</div>
                </div>
              </div>
              <div class="form-group">
                <div class="password-box">
                  <input v-model="password" class="auth-input" name="password" :type="passwordType ? 'password' : 'text'" placeholder="Enter a password" autocomplete="off" />
                  <div class="showPassContainer" @click="toggleType('passwordType')">
                    <IconBase
                      icon-name="Reverse"
                      class="showPass inline"
                      iconColor="#d6d6d6
                "
                      viewBox="0 0 128 128"
                      width="30"
                      height="30"
                    >
                      <IconShow v-if="passwordType" />
                      <IconHide v-if="!passwordType" />
                    </IconBase>
                  </div>
                </div>
                <div v-if="getError('password')" class="inputErrorContainer">
                  <div class="inputErrorText">{{ getError("password") }}</div>
                </div>
              </div>
              <div class="form-group last-form-group">
                <div class="password-box">
                  <input v-model="passwordCheck" class="auth-input" name="passcheck" :type="passwordCheckType ? 'password' : 'text'" placeholder="Confirm password" autocomplete="off" />
                  <div class="showPassContainer" @click="toggleType('passwordCheckType')">
                    <IconBase
                      icon-name="Reverse"
                      class="showPass inline"
                      iconColor="#d6d6d6
                "
                      viewBox="0 0 128 128"
                      width="30"
                      height="30"
                    >
                      <IconShow v-if="passwordCheckType" />
                      <IconHide v-if="!passwordCheckType" />
                    </IconBase>
                  </div>
                </div>
                <div v-if="getError('passcheck')" class="inputErrorContainer">
                  <div class="inputErrorText">{{ getError("passcheck") }}</div>
                </div>
              </div>
            </div>
            <div class="buttonGroup">
              <input :disabled="submitting" class="auth-button" type="submit" value="Join Cofocus" />
            </div>
          </form>
          <div class="terms">
            By creating an account, you agree to Cofocus's
            <a href="/information/terms" class="info-link">Terms of Service</a>
            and
            <a href="/information/privacy" class="info-link">Privacy Policy</a>.
          </div>
          <a class="auth-alt-button" href="/account/login">
            Already have an account?
          </a>
        </div>
      </div>
    </div>
  </app-page-container>
</template>

<script>
import auth from "../../api/auth";
import IconBase from "../../components/IconBase";
import IconShow from "../../components/SVG/IconShow";
import IconHide from "../../components/SVG/IconHide";
import AppPageContainer from "@/components/AppPageContainer.vue";
import { mapState } from "vuex";
import InternalAPI from "../../ELYX/Internal/InternalAPI"

export default {
  name: "Register",
  
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  data() {
    return {
      email: "",
      password: "",
      passwordCheck: "",
      errors: [],
      passwordCheckType: true,
      passwordType: true,
      submitting: false,
      success: false,
      registrationMethod: "",
    };
  },
  components: {
    IconBase,
    IconShow,
    IconHide,
    AppPageContainer,
  },
  mounted() {
    window.mixpanel.track("Visit Registration Page");
    InternalAPI.logEvent("ClickButton", "Sign Up Page");
  },
  methods: {
    toggleType(type) {
      this[type] = !this[type];
    },
    async register() {
      this.submitting = true;
      try {
        const { email, password, passwordCheck } = this;
        //axios.defaults.withCredentials=true;
        const response = await auth.register({
          email,
          password,
          passcheck: passwordCheck,
          hostname: window.location.host,
        });
        this.errors = [];
        this.success = true;
        this.registrationMethod = "local";
        console.log("registration successful: ", response.data);
        if (response && response.data && response.data.user && response.data.user._id) {
          window.mixpanel.track("Click Sign Up");
          window.mixpanel.alias(response.data.user._id);
        }
        // this.$router.push("/");
        this.$router.push("/signup/onboarding");
        /* window.location = "/signup/onboarding"; */
      } catch (error) {
        if (error.response && error.response.status === 422) {
          console.error("ERRO!!!!", error);
          if (error.response.data.private) {
            console.log("WASSUP");
            this.errors = [error.response.data.private];
          } else {
            this.errors = error.response.data.errors;
            console.log(this.errors);
          }
        } else {
          console.error(error);
          console.log("internal server error");
        }
      } finally {
        this.submitting = false;
      }
    },
    getError(field) {
      const error = this.errors.filter((each) => each.param === field)[0];
      return error ? error.msg : "";
    },
  },
};
</script>

<style scoped>
.external-auth {
  padding: 10px;
  color: #3e3a54;
}
.registration {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
}
.registration-block {
  max-width: 350px;
  width: 325px;
  text-align: center;
}
.auth-button {
  outline: none;
  background-color: #252525;
  color: white;
  font-size: 23px;
  font-weight: bold;
  border: unset;
  padding: 6px;
  width: 95%;
  cursor: pointer;
  font-family: "Nunito", sans-serif;
  margin-top: 8px;
  border-radius: 360px;
}
.auth-button:hover {
  background-color: #37373a;
}

.auth-alt-button {
  color: #252525;
  display: block;
  margin-top: 12px;
}

.auth-alt-button:hover {
  color: #5f5f61;
}

.auth-form {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}
.auth-header {
  margin-bottom: 30px;
}
.auth-title {
  font-size: 74px;
  font-weight: bold;
  color: #252525;
  display: block;
}

.auth-title:hover {
  color: #37373a;
}

.auth-subtitle {
  color: #252525;
  font-size: 22px;
  /* font-weight: bold; */
  width: 330px;
  margin: 0 auto;
  line-height: 22px;
  font-family: "Nunito";
}
.form-groups {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  justify-content: center;
  position: relative;
}

.form-group input {
  width: 100%;
  border: none;
  border: 1px solid #ececec;
  border-radius: 3px;
  caret-color: #666;
  padding: 8px 19px;
  font-size: 20px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
  border-radius: 360px;
}

.form-group input:hover,
.form-group input:focus {
  border-color: #dcdcdc;
}

.showPass {
  width: 18px;
  cursor: pointer;
}
.showPassContainer {
  position: absolute;
  right: 3%;
  top: 2px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  background-color: #ffffff;
  height: calc(100% - 4px);
  padding-left: 2px;
  border-radius: 360px;
}

.inputErrorContainer {
  padding: 8px 0px;
  background-color: #f9f9f9;
  border-radius: 360px;
  margin-top: 5px;
  color: #a72143;
  font-weight: 600;
}

.password-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.terms {
  display: block;
  color: #8a8a8a;
  margin-top: -15px;
  line-height: 19px;
  font-size: 14px;
}

.info-link {
  text-decoration: underline;
  color: #444;
}

.info-link:hover {
  color: #5f5f61;
}
</style>
